import styled, { css, mediaQuery, theme } from 'academy-common-lib/utils/Styling';
import { getSectionBackgroundStyle } from '../sectionStyles';
import ACIllustration from 'academy-common-lib/components/illustration/ACIllustration';
import { H2 } from 'UIComponents/elements/headings';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIList from 'UIComponents/list/UIList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CertificationPreviewSection = styled.section.withConfig({
  displayName: "PublicPageCertificationPreview__CertificationPreviewSection",
  componentId: "sc-1cnx0si-0"
})(["min-height:200px;color:", ";display:flex;align-items:center;", " ", ""], theme.colors.OLAF, mediaQuery('mobile', css(["flex-direction:column;gap:32px;padding:24px 0 12px 0;"])), getSectionBackgroundStyle(theme.colors.EERIE));
const PublicPageCertificationPreview = ({
  title,
  iconUrl
}) => {
  return /*#__PURE__*/_jsxs(CertificationPreviewSection, {
    children: [/*#__PURE__*/_jsx("div", {
      style: {
        margin: '-12px 0 -16px 0'
      },
      children: /*#__PURE__*/_jsx(ACIllustration, {
        iconUrl: iconUrl,
        name: "certificate",
        title: title,
        width: 300
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "m-left-6",
      children: [/*#__PURE__*/_jsx(H2, {
        className: "m-bottom-1",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.certificatePreview.title"
        })
      }), /*#__PURE__*/_jsxs(UIList, {
        style: {
          paddingInlineStart: 30,
          marginBottom: 0
        },
        styled: true,
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.certificatePreview.point1"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.certificatePreview.point2"
        })]
      })]
    })]
  });
};
export default PublicPageCertificationPreview;